import { Box, Container } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, Outlet, useLocation, useParams } from 'react-router-dom';
import { useSettingsContext } from 'src/legacy/components/settings';
import { usePlacementData } from 'src/legacy/pages/placements/usePlacementData';
import { getCaseManagerListSuccess } from 'src/legacy/redux/slices/customer';
import { getPlacement } from 'src/legacy/redux/slices/placement';
import { useDispatch } from 'src/legacy/redux/store';
import { PATH_DASHBOARD } from 'src/legacy/routes/paths';
import { appRoutePaths } from 'src/routes';
import { Tabs } from 'src/shared/components/Tabs';

export const PlacementDetailsNavigator = () => {
  const { id } = useParams();

  if (!id) throw new Error('id is required');

  const { themeStretch } = useSettingsContext();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { initialize } = usePlacementData();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => initialize, []);

  useEffect(() => {
    if (id) {
      dispatch(getPlacement(Number(id)));
      dispatch(getCaseManagerListSuccess(null));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <Container maxWidth={themeStretch ? false : 'lg'}>
      <Tabs
        items={[
          {
            label: t('PROFILE'),
            link: true,
            value: PATH_DASHBOARD.placement.profile(id),
          },
          {
            label: t('NOTES'),
            link: true,
            value: generatePath(appRoutePaths.placementNoteListView, {
              id,
            }),
          },
        ]}
        sx={{ mb: 3 }}
        value={pathname}
      />

      <Box>
        <Outlet />
      </Box>
    </Container>
  );
};
